<template>
	<table class="list_tbl sticky_list_tbl" v-columns-resizable>
		<thead>
			<tr>
				<th width="20%">Receipt Type</th>
				<th width="20%">Amount($)</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<template v-for="(date, summaryIndex) in date_summary_data">
				<tr v-bind:key="summaryIndex">
					<td colspan="3" class="al_left">
						<b>{{ date.valid_receipt_date }}</b>
					</td>
				</tr>
				<tr v-for="(type, typeIndex) in date.type_list" v-bind:key="summaryIndex + '/' + typeIndex">
					<td class="al_center">{{ type.display }}</td>
					<td class="al_right">{{ type.amount | toCurrency }}</td>
					<td></td>
				</tr>
				<tr v-bind:key="summaryIndex + '/total'">
					<td class="al_center"><b>Sub Total</b></td>
					<td class="al_right">{{ date.total | toCurrency }}</td>
					<td></td>
				</tr>
			</template>
			<tr>
				<td class="al_center"><b>Grand Total</b></td>
				<td class="al_right">{{ grandTotal | toCurrency }}</td>
				<td></td>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
	name: 'summaryDateTable',
	props: {
		date_summary_data: {},
		grandTotal: {},
	},
};
</script>
